var lists_default = {
  "fontElementMap": "_46sGv",
  "orderedlist": "CMRv5",
  "bulletedlist": "qeDu4",
  "listItem": "b27zF"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
